module.exports = __webpack_public_path__ + "img/user.6e4ddbee.png";